document.addEventListener('alpine:init', () => {
    /** example for event structure:
     * event: {
            on: 'click',
            eventHandler: 'resetSearch',
            options: {
                ...
            },
        }
     */

    /* Clear "search" input field */
    window.Alpine.magic('resetSearch', () => event => {
        event._x_model.set('');
        event.focus();
    });

    /* Clear "file" input field */
    window.Alpine.magic('resetFile', () => event => {
        event._x_model.set('');
    });
});
